export const Layout = () => import('@/layout/index.vue')
import { getRouteRoles } from '@/utils/index'

/**
 * 系统管理路由
 */
const routes = {
  path: '/system',
  redirect: 'noRedirect',
  component: Layout,
  meta: {
    icon: 'SetUp',
    title: '系统管理',
    roles: [],
    activeMenuTop: '/system',
    hidden: false,
    keepAlive: true,
    alwaysShow: false
  },
  children: [
    {
      path: 'setting',
      name: 'SystemSetting',
      component: () => import('@/views/system/setting/setting.vue'),
      meta: {
        icon: 'SetUp',
        title: '后台系统配置',
        roles: [
          'admin/system.Setting/systemInfo',
          'admin/system.Setting/captchaInfo',
          'admin/system.Setting/emailInfo',
          'admin/system.Setting/logInfo',
          'admin/system.Setting/cacheInfo',
          'admin/system.Setting/apiInfo',
          'admin/system.Setting/tokenInfo',
          'admin/system.Setting/serverInfo',
          'admin/system.UserCenter/setting'
        ],
        activeMenuTop: '/system',
        hidden: false,
        keepAlive: true,
        alwaysShow: false
      }
    },
    {
      path: 'user',
      name: 'SystemUser',
      redirect: 'noRedirect',
      meta: {
        icon: 'UserFilled',
        title: '后台用户管理',
        roles: ['admin/system.User/list'],
        activeMenuTop: '/system',
        hidden: false,
        keepAlive: true,
        alwaysShow: false
      },
      children: [
        {
          path: 'list',
          name: 'SystemUserList',
          component: () => import('@/views/system/user/list.vue'),
          meta: {
            title: '后台用户管理',
            roles: ['admin/system.User/list'],
            activeMenuTop: '/system',
            hidden: false,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'info/:id',
          name: 'SystemUserInfo',
          component: () => import('@/views/system/user/info.vue'),
          meta: {
            title: '用户信息',
            roles: ['admin/system.User/list'],
            activeMenu: '/system/user/list',
            activeMenuTop: '/system',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'add',
          name: 'SystemUserAdd',
          component: () => import('@/views/system/user/add.vue'),
          meta: {
            title: '用户添加',
            roles: ['admin/system.User/list'],
            activeMenu: '/system/user/list',
            activeMenuTop: '/system',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'edit/:id',
          name: 'SystemUserEdit',
          component: () => import('@/views/system/user/edit.vue'),
          meta: {
            title: '用户修改',
            roles: ['admin/system.User/list'],
            activeMenu: '/system/user/list',
            activeMenuTop: '/system',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        }
      ]
    },
    {
      path: 'role',
      name: 'SystemRole',
      redirect: 'noRedirect',
      meta: {
        icon: 'Avatar',
        title: '角色管理',
        roles: ['admin/system.Role/list'],
        activeMenuTop: '/system',
        hidden: false,
        keepAlive: true,
        alwaysShow: false
      },
      children: [
        {
          path: 'list',
          name: 'SystemRoleList',
          component: () => import('@/views/system/role/list.vue'),
          meta: {
            title: '角色管理',
            roles: ['admin/system.Role/list'],
            activeMenuTop: '/system',
            hidden: false,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'info/:id',
          name: 'SystemRoleInfo',
          component: () => import('@/views/system/role/info.vue'),
          meta: {
            title: '角色信息',
            roles: ['admin/system.Role/list'],
            activeMenu: '/system/role/list',
            activeMenuTop: '/system',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'add',
          name: 'SystemRoleAdd',
          component: () => import('@/views/system/role/add.vue'),
          meta: {
            title: '角色添加',
            roles: ['admin/system.Role/list'],
            activeMenu: '/system/role/list',
            activeMenuTop: '/system',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'edit/:id',
          name: 'SystemRoleEdit',
          component: () => import('@/views/system/role/edit.vue'),
          meta: {
            title: '角色修改',
            roles: ['admin/system.Role/list'],
            activeMenu: '/system/role/list',
            activeMenuTop: '/system',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        }
      ]
    },
    {
      path: 'menu',
      name: 'SystemMenu',
      redirect: 'noRedirect',
      meta: {
        icon: 'Menu',
        title: '菜单管理',
        roles: ['admin/system.Menu/list'],
        activeMenuTop: '/system',
        hidden: false,
        keepAlive: true,
        alwaysShow: false
      },
      children: [
        {
          path: 'list',
          name: 'SystemMenuList',
          component: () => import('@/views/system/menu/list.vue'),
          meta: {
            title: '菜单管理',
            roles: ['admin/system.Menu/list'],
            activeMenuTop: '/system',
            hidden: false,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'info/:id',
          name: 'SystemMenuInfo',
          component: () => import('@/views/system/menu/info.vue'),
          meta: {
            title: '菜单信息',
            roles: ['admin/system.Menu/list'],
            activeMenu: '/system/menu/list',
            activeMenuTop: '/system',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'add/:pid?',
          name: 'SystemMenuAdd',
          component: () => import('@/views/system/menu/add.vue'),
          meta: {
            title: '菜单添加',
            roles: ['admin/system.Menu/list'],
            activeMenu: '/system/menu/list',
            activeMenuTop: '/system',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'edit/:id',
          name: 'SystemMenuEdit',
          component: () => import('@/views/system/menu/edit.vue'),
          meta: {
            title: '菜单修改',
            roles: ['admin/system.Menu/list'],
            activeMenu: '/system/menu/list',
            activeMenuTop: '/system',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        }
      ]
    },
    // {
    //   path: 'apidoc',
    //   name: 'SystemApidoc',
    //   component: () => import('@/views/system/apidoc/apidoc.vue'),
    //   meta: {
    //     icon: 'Document',
    //     title: '接口文档',
    //     roles: ['admin/system.Apidoc/apidoc'],
    //     activeMenuTop: '/system',
    //     hidden: false,
    //     keepAlive: true,
    //     alwaysShow: false
    //   }
    // },
    {
      path: 'user-center',
      name: 'SystemUserCenter',
      component: () => import('@/views/system/user-center/index.vue'),
      meta: {
        icon: 'User',
        title: '个人中心',
        roles: [],
        activeMenuTop: '/system',
        hidden: false,
        keepAlive: true,
        alwaysShow: false
      }
    }
  ]
}

routes.meta.roles = getRouteRoles(routes)

export default routes
